import { H } from 'components';
import Prac01 from './Prac01';
import Prac02 from './Prac02';
import Prac03 from './Prac03';
import Prac04 from './Prac04';
import Prac05 from './Prac05';
import Prac06 from './Prac06';
import Prac07 from './Prac07';
import Prac08 from './Prac08';
import Prac09 from './Prac09';
import Prac10 from './Prac10';
import Prac11 from './Prac11';
import Prac12 from './Prac12';
import Prac13 from './Prac13';
import Prac14 from './Prac14';
import Task01 from './Task01';
import Task02 from './Task02';
import Task03 from './Task03';
import Task04 from './Task04';
import Task05 from './Task05';
import Task06 from './Task06';
import Task07 from './Task07';
import Task08 from './Task08';
import Task09 from './Task09';
import Task10 from './Task10';
import Task11 from './Task11';
import Task12 from './Task12';

const tasks = [
  {
    title: <H level={2}>prac 01: referencing values with refs</H>,
    task: <Prac01 />,
  },
  {
    title: <H level={2}>prac 02: starting a stopwatch</H>,
    task: <Prac02 />,
  },
  {
    title: <H level={2}>prac 03: building a stopwatch</H>,
    task: <Prac03 />,
  },
  {
    title: <H level={2}>prac 04: difference between refs and state</H>,
    task: <Prac04 />,
  },
  {
    title: <H level={2}>task 01: fix a broken chat input</H>,
    task: <Task01 />,
  },
  {
    title: <H level={2}>task 02: fix a component failed to re-render</H>,
    task: <Task02 />,
  },
  {
    title: <H level={2}>task 03: fix debouncing</H>,
    task: <Task03 />,
  },
  {
    title: <H level={2}>task 04: read the latest state</H>,
    task: <Task04 />,
  },
  {
    title: <H level={2}>prac 05: manipulating the dom with refs</H>,
    task: <Prac05 />,
  },
  {
    title: <H level={2}>prac 06: scrolling to an element</H>,
    task: <Prac06 />,
  },
  {
    title: <H level={2}>prac 07: managing a refs list using a ref callback</H>,
    task: <Prac07 />,
  },
  {
    title: <H level={2}>prac 08: accessing another component's dom node</H>,
    task: <Prac08 />,
  },
  {
    title: <H level={2}>prac 09: flushing state updates sync with flushsync</H>,
    task: <Prac09 />,
  },
  {
    title: <H level={2}>prac 10: best pracices for dom control with refs</H>,
    task: <Prac10 />,
  },
  {
    title: <H level={2}>task 05: play and pause the video</H>,
    task: <Task05 />,
  },
  {
    title: <H level={2}>task 06: focus the search field</H>,
    task: <Task06 />,
  },
  {
    title: <H level={2}>task 07: scrolling an image carousel</H>,
    task: <Task07 />,
  },
  {
    title: <H level={2}>task 08: focusing search field by other components</H>,
    task: <Task08 />,
  },
  {
    title: <H level={2}>prac 11: declare an effect</H>,
    task: <Prac11 />,
  },
  {
    title: <H level={2}>prac 12: specify the effect dependancies</H>,
    task: <Prac12 />,
  },
  {
    title: <H level={2}>prac 13: add cleanup if needed</H>,
    task: <Prac13 />,
  },
  {
    title: <H level={2}>prac 14: putting it all together</H>,
    task: <Prac14 />,
  },
  {
    title: <H level={2}>task 09: focus on field on mount</H>,
    task: <Task09 />,
  },
  {
    title: <H level={2}>task 10: focus a field conditionally</H>,
    task: <Task10 />,
  },
  {
    title: <H level={2}>task 11: fix an interval that fires twice</H>,
    task: <Task11 />,
  },
  {
    title: <H level={2}>task 12: fix fetching inside an effect</H>,
    task: <Task12 />,
  },
];

export { tasks };
